<template>
  <div class="webFooter">
    <span style="margin-left: 10%">首页</span>
    <span>登录</span>
    <span>注册</span>
    <span>关于我们</span>
  </div>
</template>

<script>
export default {
  name: "WebFooter"
}
</script>

<style scoped>

.webFooter {
  background-color: #ff450026;
  width: 100%;
  height: 100%;
}

.webFooter >>> span {
  float: left;
  margin-left: 1%;
}
</style>